/**
 * Compares two lists of objects based on their tripID, panic, and tripStatus properties
 * @param {Array<Object>} listA - List gotten from database
 * @param {Array<Object>} listB - List saved into ref
 * @returns {Boolean} Returns true if the lists are equivalent and false otherwise.
 */
export const compareTripList = (listA, listB) => {
    if (listA.length !== listB.length) return false

    const idsA = new Set(listA.map((obj) => obj.tripID))
    const idsB = new Set(listB.map((obj) => obj.tripID))

    const eqSet = [...idsA].every((x) => idsB.has(x))

    if (!eqSet) return false

    const mapById = new Map(listB.map((item) => [item.tripID, item]))

    for (const item1 of listA) {
        const item2 = mapById.get(item1.tripID)

        if (item2) {
            if (
                item1.panic !== item2.panic ||
                item1.tripStatus !== item2.tripStatus
            ) return false
        }
    }

    return true
}

/**
 * Subtracts elements from listB from listA based on the tripID and panic properties
 * @param {Array<Object>} listA - List gotten from database
 * @param {Array<Object>} listB - List saved into ref
 * @returns {Array<Object>} Returns a new array from listA that satisfy some change in IDs and panic alert
 */
export const subtractList = (listA, listB) =>
    listA.filter((a) => {
        const matchingTrip = listB.find((b) => b.tripID === a.tripID)
        return !matchingTrip || (a.panic !== matchingTrip.panic)
    })